let win;

if (typeof window !== "undefined") {
  win = window;
} else {
  win = {};
}

export { win as window };
